<div class="modal-header w-100 mb-3">
  <div class="modal-title">
    <h1 class="title-lg">Select a Client</h1>
    <h6 class="title-desc text-start">
      Please select a client inorder to show prices for.
    </h6>
  </div>
  <i class="close btn-close" (click)="onNoClick()"></i>
</div>
<div mat-dialog-content>
  <!--<img src="../../../../assets/Images/ClientDia.png" class="bg">-->
  <div class="shopping-as-client-header">
    <span class="material-icons-outlined"> directions_boat </span>
  </div>
  <form [formGroup]="selectedUserForm" (submit)="onSubmit()" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="w-100 input-field">
          <mat-label> Select Client* </mat-label>
          <mat-form-field appearance="outline">
            <mat-select
              (selectionChange)="getEmployees($event)"
              formControlName="company"
            >
              <mat-option
                *ngFor="let company of data.companies"
                [value]="company"
              >
                {{ company.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="selectedUserForm.controls['company'].hasError('required')"
            >
              This field is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12">
        <div class="w-100 input-field">
          <mat-label> Select Client's User </mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="user">
              <mat-option *ngFor="let user of users.data" [value]="user">
                {{ user.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="selectedUserForm.controls['user'].hasError('noUsers')"
            >
              This Company Doesn't Have Users
            </mat-error>
            <mat-error
              *ngIf="selectedUserForm.controls['user'].hasError('required')"
            >
              This field is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="float-end modal-footer w-100">
      <button class="btn btn-secondary m-2" (click)="onNoClick()" type="button">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary float-end m-2">
        Continue
      </button>
    </div>
  </form>
</div>
